import { render } from "./DonationInfo.vue?vue&type=template&id=93b25956&scoped=true&ts=true"
import script from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DonationInfo.vue?vue&type=style&index=0&id=93b25956&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93b25956"],['__file',"src/js/components/style-six/DonationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93b25956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93b25956', __exports__)) {
    api.reload('93b25956', __exports__)
  }
  
  module.hot.accept("./DonationInfo.vue?vue&type=template&id=93b25956&scoped=true&ts=true", () => {
    api.rerender('93b25956', render)
  })

}


export default __exports__